angular.module('lsnBase.stringPremium', []);